import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ITrainingPhaseResource } from "../types";

export interface ITrainingPhaseDeleteMutationParameters {
    trainingPhase: RelationalValue<ITrainingPhaseResource>;
}

export type ITrainingPhaseDeleteMutationResult = void;

export const trainingPhaseDeleteMutation: IApiMutationFunction<ITrainingPhaseDeleteMutationParameters> = ({
    trainingPhase,
}) => {
    return {
        method: "DELETE",
        url: `/training_phases/${mapRelationalValue(trainingPhase)}`,
    };
};

export const useTrainingPhaseDeleteMutation = createApiMutationHook<
    ITrainingPhaseDeleteMutationParameters,
    ITrainingPhaseDeleteMutationResult
>(trainingPhaseDeleteMutation);
